// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../shared/Util.re.mjs";
import * as Lingui from "../../locales/Lingui.re.mjs";
import * as Router from "../shared/Router.re.mjs";
import * as RelayEnv from "../../entry/RelayEnv.re.mjs";
import * as Localized from "../shared/i18n/Localized.re.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.re.mjs";
import * as PkLocationPage from "../pages/PkLocationPage.re.mjs";
import * as EventsListUtils from "../shared/EventsListUtils.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as PkLocationPageQuery_graphql from "../../__generated__/PkLocationPageQuery_graphql.re.mjs";

var LoaderArgs = {};

var loadMessages = Lingui.loadMessages({
      en: import("../../locales/src/components/pages/PkLocationPage.re/en"),
      ja: import("../../locales/src/components/pages/PkLocationPage.re/ja"),
      th: import("../../locales/src/components/pages/PkLocationPage.re/th"),
      zhTW: import("../../locales/src/components/pages/PkLocationPage.re/zh-TW"),
      zhCN: import("../../locales/src/components/pages/PkLocationPage.re/zh-CN"),
      ko: import("../../locales/src/components/pages/PkLocationPage.re/ko"),
      vi: import("../../locales/src/components/pages/PkLocationPage.re/vi")
    });

async function loader(param) {
  var params = param.params;
  var url = new URL(param.request.url);
  var after = Router.SearchParams.get(url.searchParams, "after");
  var before = Router.SearchParams.get(url.searchParams, "before");
  var afterDate = Core__Option.map(Router.SearchParams.get(url.searchParams, "afterDate"), (function (d) {
          return Util.Datetime.fromDate(new Date(d));
        }));
  if (import.meta.env.SSR) {
    await Localized.loadMessages(params.lang, loadMessages);
  }
  return ReactRouterDom.defer({
              data: PkLocationPageQuery_graphql.load(RelayEnv.getRelayEnv(param.context, import.meta.env.SSR), {
                    after: after,
                    afterDate: afterDate,
                    availabilityFromDate: EventsListUtils.availabilityFromDate(),
                    availabilityToDate: EventsListUtils.availabilityToDate(),
                    before: before,
                    id: params.locationId
                  }, "store-or-network", undefined, undefined),
              i18nLoaders: import.meta.env.SSR ? undefined : Caml_option.some(Localized.loadMessages(params.lang, loadMessages))
            });
}

var Component = PkLocationPage.make;

export {
  Component ,
  LoaderArgs ,
  loadMessages ,
  loader ,
}
/* loadMessages Not a pure module */
